module.exports = __webpack_public_path__ + "static/img/zhibo.6aec88d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhibo.png
// module id = Xkei
// module chunks = 1